/**
 * Message Area - Displays messages and input
 */

import React, { useState } from 'react';
import { Empty } from 'antd';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { ChatHeader } from './ChatHeader';
import './MessageArea.css';

interface MessageAreaProps {
  channelId: string | null;
  showChannelInfo?: boolean;
  onToggleChannelInfo?: () => void;
  onOpenThread?: (messageId: string) => void;
}

export const MessageArea: React.FC<MessageAreaProps> = ({ 
  channelId, 
  showChannelInfo = false,
  onToggleChannelInfo,
  onOpenThread
}) => {
  const [replyingToMessageId, setReplyingToMessageId] = useState<string | null>(null);

  const handleReplyToMessage = (messageId: string) => {
    setReplyingToMessageId(messageId);
  };

  const handleCancelReply = () => {
    setReplyingToMessageId(null);
  };

  if (!channelId) {
    return (
      <div className="message-area-empty">
        <Empty description="Select a conversation or start a new chat" />
      </div>
    );
  }

  return (
    <div className={`message-area ${showChannelInfo ? 'has-right-sidebar' : ''}`}>
      <ChatHeader channelId={channelId} />
      <div className="message-list-container" ref={(el) => {
        if (el) {
          (window as any).chatMessageListContainer = el;
        }
      }}>
        <MessageList 
          channelId={channelId} 
          onReplyToMessage={handleReplyToMessage}
          onOpenThread={onOpenThread}
        />
      </div>
      <div className="message-input-container">
        <MessageInput 
          channelId={channelId} 
          replyTo={replyingToMessageId}
          onCancelReply={handleCancelReply}
        />
      </div>
    </div>
  );
};

